import type { ErrorCodes } from "../types/ErrorCodes";

export function validateErrorCode(errorCode: ErrorCodes | null | undefined): boolean {
    try {
        if (errorCode && typeof errorCode === "string") {
            return !isNaN(parseInt(errorCode.charAt(0)));
        }
    }
    catch {
        // do nothing
    }
    
    return false;
}
